import React, { useEffect, useRef, useState } from 'react';
import '../styles/Hero3D.css';

const Hero3DShowcase = () => {
  const showcaseRef = useRef(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (window.innerWidth < 768) return;
      
      const { clientX, clientY } = e;
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      
      const x = (clientX - centerX) / centerX;
      const y = (clientY - centerY) / centerY;
      
      setMousePosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="hero-3d-showcase" ref={showcaseRef}>
      {/* Luxury light rays */}
      <div className="light-rays">
        <div className="ray ray-1"></div>
        <div className="ray ray-2"></div>
        <div className="ray ray-3"></div>
      </div>

      {/* Floating particles */}
      <div className="particles-container">
        {[...Array(20)].map((_, i) => (
          <div 
            key={i} 
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${10 + Math.random() * 10}s`
            }}
          />
        ))}
      </div>

      {/* 3D Product layers with parallax */}
      <div 
        className="product-layers"
        style={{
          transform: `
            perspective(1000px)
            rotateY(${mousePosition.x * 5}deg)
            rotateX(${-mousePosition.y * 5}deg)
          `
        }}
      >
        {/* Background glass panel */}
        <div 
          className="glass-panel glass-back"
          style={{
            transform: `translateZ(-100px) translateX(${mousePosition.x * -20}px) translateY(${mousePosition.y * -20}px)`
          }}
        />

        {/* Middle glass panel */}
        <div 
          className="glass-panel glass-mid"
          style={{
            transform: `translateZ(0px) translateX(${mousePosition.x * -10}px) translateY(${mousePosition.y * -10}px)`
          }}
        />

        {/* Front product spotlight */}
        <div 
          className="product-spotlight"
          style={{
            transform: `translateZ(50px) translateX(${mousePosition.x * 5}px) translateY(${mousePosition.y * 5}px)`
          }}
        />
      </div>

      {/* Golden glow accent */}
      <div className="golden-glow"></div>
    </div>
  );
};

export default Hero3DShowcase;
